import { Button, Component, Node, _decorator } from 'cc';

const { ccclass, property, executeInEditMode } = _decorator;

@ccclass('ButtonStateEffect')
@executeInEditMode
export default abstract class ButtonStateEffect<T extends Component | Node> extends Component {
    @property({ type: Button, formerlySerializedAs: 'target' })
    private _target: Button = null;

    private _effectTarget: T = null;

    @property(Button)
    protected get target(): Button {
        return this._target ?? this.getComponent(Button);
    }
    protected set target(value: Button) {
        if (this._target === value) {
            return;
        }
        if (this._target) {
            this._unregisterTargetEvents();
        }
        this._target = value;
        if (this._target) {
            this._registerTargetEvents();
            this.syncState();
        }
    }

    protected get effectTarget(): T {
        if (!this._effectTarget) {
            this._effectTarget = this.getEffectTarget();
        }
        return this._effectTarget;
    }

    public onEnable() {
        this._registerTargetEvents();
        this.syncState();
    }

    public onDisable() {
        this._unregisterTargetEvents();
    }

    public syncState() {
        if (!this.target) {
            return;
        }
        this._executeUpdateState(this.target.getButtonState());
    }

    private _registerTargetEvents() {
        const { target } = this;
        if (!target) {
            return;
        }
        target.on(Button.EventType.APPLY_TRANSITION, this._executeUpdateState, this);
        target.on(Button.EventType.STATE_RESET, this.syncState, this);
    }

    private _unregisterTargetEvents() {
        const { target } = this;
        if (!target) {
            return;
        }
        target.off(Button.EventType.APPLY_TRANSITION, this._executeUpdateState, this);
        target.off(Button.EventType.STATE_RESET, this.syncState, this);
    }

    private _executeUpdateState(state: Button.State) {
        // check if effect target is exist before updating state
        if (!this.effectTarget) {
            return;
        }
        this.updateState(state);
    }

    protected abstract getEffectTarget(): T;
    protected abstract updateState(state: Button.State): void;
}
